<!-- {{authState$|async|json}} -->
<div class="home">
  <div id="loginZone">
    <img src="images/img/LOGO-TMU-home.png" class="homeTMU">
    <img src="images/img/LOGO-Home.png" class="homeLOGO">

    <!-- <a href="javascript:void(0)" class="login" (click)="login()"></a> -->

    <div
      style="    display: block;    float: right;    margin: 70px 120px 20px 0;    display: block;    float: right;    clear: both;    width: 90%;    max-width: 756px;">
      <div class="login">
        <div class="login-icon">
          <asl-google-signin-button type='icon' size='large' shape="circle" width="400"></asl-google-signin-button>
        </div>
        <div class="login-text">
          登&nbsp;&nbsp;&nbsp;&nbsp;入
        </div>


      </div>
    </div>


    <div id="homeTel">
      若您對系統有疑問或建議，請寄信至
      <i class="far fa-envelope"></i>
      <a href="mailto:paced_group@tmu.edu.tw" target="_blank">服務信箱</a>
      &nbsp;
      <i class="far fa-question-circle"></i>
      <a target="_blank"
        [href]="('https://docs.google.com/document/d/e/2PACX-1vSsOAc1wt9BCFCnIToyDi447DQRMAUnDijN-7W2587uAk1ZnmwNmjTM0vODheUyWljzNnzRTlB773hU/pub'|translate)">
        系統操作手冊
      </a>
      &nbsp;
      <i class="fa-solid fa-video"></i>
      <a target="_blank"
        [href]="('https://drive.google.com/file/d/1VGKMX9r6zef4VN_gifNipbC_ApK0i2fr/view?usp=sharing，'|translate)">
        教學影片
      </a>
    </div>
    <div id="homeCopy">Copyright &copy; 2022 臺北醫學大學 Taipei Medical University</div>
  </div>
</div>


<!-- <button (click)="logout()">登出</button> -->

<!-- {{authState|async|json}} -->